import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FaUniversity, FaUsers, FaRegBuilding } from 'react-icons/fa';

import PageHeader from '../../Components/PageHeader/PageHeader';
import TTrainingPrograms from '../../Components/TTrainingPrograms/TTrainingPrograms';
import TCertificateCourses from '../../Components/TCertificateCourses/TCertificateCourses';
import TTrainingCompendium from '../../Components/TTrainingCompendium/TTrainingCompendium';
import TRightComponent from '../../Components/TRightComponent/TRightComponent';
import Future_Ready_Infrastructure_for_Cities from '../../Components/TrainingContentComp/CertificateCourses/Future_Ready_Infrastructure_for_Cities';
import Application_of_Geo_Informatics_for_Planning from '../../Components/TrainingContentComp/CertificateCourses/Application_of_Geo_Informatics_for_Planning';
import Spaces from '../../Components/TrainingContentComp/CertificateCourses/Spaces';
import Urban_Heat_Island from '../../Components/TrainingContentComp/TrainingPrograms/Urban_Heat_Island';
import SPPOS from '../../Components/TrainingContentComp/TrainingPrograms/SPPOS';
import Water_Supply_Systems_and_Management_for_UBL from '../../Components/TrainingContentComp/TrainingPrograms/Water_Supply_Systems_and_Management_for_UBL';
import STP_Management_and_Operations from '../../Components/TrainingContentComp/TrainingPrograms/STP_Management_and_Operations';
import Using_Building_Envelopes_as_Heat_Sink_to_Manage_Urban_Heat_Island from '../../Components/TrainingContentComp/TrainingCompendium/Using_Building_Envelopes_as_Heat_Sink_to_Manage_Urban_Heat_Island';
import Determinants_of_Successful_Public_Parks_and_Open_Spaces from '../../Components/TrainingContentComp/TrainingCompendium/Determinants_of_Successful_Public_Parks_and_Open_Spaces';
import Case_Specific_to_India_Himalayan_Region from '../../Components/TrainingContentComp/TrainingCompendium/Case_Specific_to_India_Himalayan_Region';
import Fire_safety_in_Informal_settlements from '../../Components/TrainingContentComp/TrainingCompendium/Fire_safety_in_Informal_settlements';
import Disaster_Impact_Resilience_of_Critical_Infrastructure from '../../Components/TrainingContentComp/TrainingCompendium/Disaster_Impact_Resilience_of_Critical_Infrastructure';
import Rethinking_Public_Spaces_Under_Fly_Overs from '../../Components/TrainingContentComp/TrainingPrograms/Rethinking_Public_Spaces_Under_Fly_Overs';
import Urbanization_Hill_Town from '../../Components/TrainingContentComp/TrainingPrograms/Urbanization_Hill_Town';
import Fire_Risk_and_Vulnerabilities_Informal_Settlements from '../../Components/TrainingContentComp/TrainingPrograms/Fire_Risk_and_Vulnerabilities_Informal_Settlements';

import './Training.css'

const Training = () => {

    const location = useLocation();

    useEffect(() => {
        const pathname = location.pathname;
        let trimmedPathname = pathname;
        if (pathname.endsWith("/")) {
            trimmedPathname = pathname.slice(0, pathname.length - 1); // Remove trailing slash if present
        }
        const segments = trimmedPathname.split("/");
        setOpenSection(segments[segments.length - 1])
    }, [location])

    const [openSection, setOpenSection] = useState();
    const [showDetailRight, setShowDetailRight] = useState(1)

    const menuItems = [
        {
            id: 1,
            title: 'Training Programs',
            path: 'trainingPrograms',
            icon: <FaUniversity />,
            // content: <TTrainingPrograms />,
            subDrop: [
                {
                    id: 1,
                    tab_title: "Urban Heat Island",
                    title: "Using Building Envelopes as Heat Sinks to Manage Urban Heat Island (UHI) in Developing Countries: A Context-Specific Approach",
                    path: 'tp1',
                    content: <Urban_Heat_Island />
                },
                {
                    id: 2,
                    tab_title: "Public Parks and Open Spaces",
                    title: "Determinants of Successful Public Parks and Open Spaces (SPPOS)",
                    path: 'tp2',
                    content: <SPPOS />
                },
                {
                    id: 3,
                    tab_title: "Water and Sewage System Operation and Management",
                    title: "Three Day’s Certified Course on Water, Sewage Management, STP Management, Plumbing & Allied Sectors",
                    path: 'tp3',
                    content: <Water_Supply_Systems_and_Management_for_UBL />,
                },
                {
                    id: 4,
                    tab_title: "‘Rethinking’ Public Spaces Under Fly-Overs",
                    title: `3 - Days Professional Development Program on ‘Rethinking’ Public Spaces Under Fly-Overs`,
                    path: 'tp4',
                    content: <Rethinking_Public_Spaces_Under_Fly_Overs />,
                },
                {
                    id: 5,
                    tab_title: `Fire Risk and Vulnerabilities in Informal Settlements`,
                    title: `3 - Days Professional Development Program on ‘ Fire Risk and Vulnerabilities in Informal Settlements: Complexities, Modelling, and Strategies for Risk Mitigation’`,
                    path: 'tp5',
                    content: <Fire_Risk_and_Vulnerabilities_Informal_Settlements />,
                },
                {
                    id: 6,
                    tab_title: `Urbanization in the Hill Town`,
                    title: `3 - Days Professional Development Program  on ‘Resilient and Responsive Urbanization in the Hill Town ’`,
                    path: 'tp5',
                    content: <Urbanization_Hill_Town />,
                },
            ],
        },
        {
            id: 2,
            title: 'Certificate Courses',
            path: 'certificateCourses',
            icon: <FaUsers />,
            // content: <TCertificateCourses />,
            subDrop: [
                {
                    id: 1,
                    title: "SPACES",
                    tab_title: "SPACES",
                    path: 'tcc3',
                    content: <Spaces />,
                },
                {
                    id: 2,
                    title: "Future Ready Infrastructure for Cities",
                    tab_title: "Future Ready Infrastructure for Cities",
                    path: 'tcc2',
                    content: <Future_Ready_Infrastructure_for_Cities />,
                },
                {
                    id: 3,
                    title: "Application of Geo-Informatics for Planning",
                    tab_title: "GIS for Planning",
                    path: 'tcc1',
                    content: <Application_of_Geo_Informatics_for_Planning />
                },
            ],
        },
        {
            id: 3,
            title: 'Training Compendium',
            path: 'trainingCompendium',
            icon: <FaRegBuilding />,
            // content: <TTrainingCompendium />,
            subDrop: [
                {
                    id: 1,
                    title: `Using Building Envelopes as Heat Sink to Manage Urban Heat Island (UHI) In Developing Countries`,
                    tab_title: "Compendium on Urban Heat Island",
                    // path: 'ttc1',
                    content: <Using_Building_Envelopes_as_Heat_Sink_to_Manage_Urban_Heat_Island />
                },
                {
                    id: 2,
                    title: `Determinants of Successful Public Parks and Open Spaces (SPPOS)`,
                    tab_title: "Compendium on Public Parks and Open Spaces",
                    // path: 'ttc2',
                    content: <Determinants_of_Successful_Public_Parks_and_Open_Spaces />
                },
                {
                    id: 3,
                    title: `Resilient and Responsive Urbanization in the Hill Town – Case Specific to India Himalayan Region (IHR)`,
                    tab_title: "Compendium on Urbanization in the Hill Town",
                    // path: 'ttc3',
                    content: <Case_Specific_to_India_Himalayan_Region />
                },
                {
                    id: 4,
                    title: `Fire safety in Informal settlements (InSe)`,
                    tab_title: "Compendium on Fire safety",
                    // path: 'ttc4',
                    content: <Fire_safety_in_Informal_settlements />
                },
                {
                    id: 5,
                    title: `Disaster Impact & Resilience of Critical Infrastructure`,
                    tab_title: "Compendium on Disaster Impact & Resilience of Critical Infrastructure",
                    // path: 'ttc5',
                    content: <Disaster_Impact_Resilience_of_Critical_Infrastructure />
                },
            ],
        },
    ]

    const toggleSection = (section) => {
        // setOpenSection(openSection === section ? null : section);
        setOpenSection(section);
        setShowDetailRight(1)
    };

    return (
        <>
            <PageHeader
                title="Training"
                breadcrumbs={[
                    { label: 'Home', href: '/' },
                    // { label: 'About', href: '/about' },
                    { label: 'Training' }
                ]}
            />
            <div className="container py-5">


                <div className='row' >
                    {/* Left Menu */}
                    <div className="col-md-3">
                        <div className="border bg-white p-4 shadow-sm rounded h-100">
                            <div className="list-group">
                                <h5 className="fw-bold text-primary mb-4 border-start border-4 ps-2 border-primary">
                                    Training
                                </h5>

                                <div className="accordion border-none" id="spaAccordion">
                                    {menuItems.map((item) => (
                                        <div className="accordion-item" key={item.id}>
                                            <h2 className="accordion-header" id={`heading-${item.id}`}>
                                                <button
                                                    className={`accordion-button ${openSection === item.path ? '' : 'collapsed'}`}
                                                    type="button"
                                                    onClick={() => toggleSection(item.path)}
                                                >
                                                    {item.title}
                                                </button>
                                            </h2>
                                            <div
                                                id={`collapse-${item.id}`}
                                                className={`accordion-collapse collapse ${openSection === item.path ? 'show' : ''}`}
                                            >
                                                <div className="accordion-body">
                                                    {item.path === openSection &&
                                                        <>
                                                            {item?.subDrop.map((item) => (
                                                                <ul className="mt-3">
                                                                    <li
                                                                        onClick={() => setShowDetailRight(item?.id)}
                                                                        className={`${showDetailRight === item.id ? 'activePannel' : ''}`}
                                                                    >
                                                                        {item.tab_title}
                                                                    </li>
                                                                </ul>
                                                            ))}
                                                        </>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right Content */}
                    <div className="col-md-9">
                        <div className="border bg-white p-4 shadow-sm rounded h-100">
                            <h5 className="fw-bold text-primary mb-4 border-start border-4 ps-2 border-primary">
                                {menuItems.find((item) => item.path === openSection)?.title}
                            </h5>

                            {/* <TRightComponent data={menuItems.find((item) => item.path === openSection)?.subDrop.find((item) => item.id === showDetailRight)?.content} /> */}
                            {menuItems.find((item) => item.path === openSection)?.subDrop.find((item) => item.id === showDetailRight)?.content}

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Training;
